<template>
  <section class="zcjy-wrapper">
    <div class="bg"></div>
    <div class="zcjy-content section">
      <div class="left">
        <img src="@/static/image/about5.png" alt="president" />
      </div>
      <div class="right">
        <div class="desc-title"><span class="active">{{ $t('presidentMessage.title') }}</span><span> / {{ $t('presidentMessage.subTitle') }}</span></div>
        <div class="diver"></div>
        <div class="content">
          <h4>{{ $t('presidentMessage.slogan') }}</h4>
          <p>{{ $t('presidentMessage.p1') }}</p>
          <p>{{ $t('presidentMessage.p2') }}</p>
          <p>{{ $t('presidentMessage.p3') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'PresidentMessage' }
</script>

<style scoped lang="scss">
.zcjy-wrapper { width: 100%; margin-top: 60px; height: 866px; position: relative; background: #f7faff; }
.bg { position: absolute; top: 0; left: 0; width: 100%; height: 600px; background: url('../../../../static/image/about-xc-zcjy.png') center/cover no-repeat; }
.section { width: 1200px; margin: 0 auto; }
.zcjy-content { position: relative; top: 80px; height: 750px; background: #fff; display: flex; }
.left { width: 510px; }
.left img { width: 100%; height: 100%; object-fit: cover; }
.right { width: 690px; }
.desc-title { margin-top: 26px; margin-left: 48px; }
.desc-title .active { color: #1c51a3; font-size: 26px; }
.diver { width: 48px; height: 2px; background: #d8d8d8; margin: 20px 0 0 48px; }
.content { margin: 20px 0 0 48px; width: 600px; color: #333;text-align: left; }
.content h4 { line-height: 1.7; }
.content p { line-height: 24px; margin-top: 16px; }
</style>

